<template>
  <el-dialog custom-class="max-dialog" title="选择对账年月" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="对账年月：" :label-width="formLabelWidth" prop="date">
            <el-date-picker
              v-model="form.date"
              type="month" :value-format="'yyyy-MM'"
              placeholder="选择年月"
              @change="changedate">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注：" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="remark">
            </el-input>
          </el-form-item>
          <el-form-item label="对账单：" :label-width="formLabelWidth">
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
            <el-button type="warning" v-on:click="importEdit">导入对账单</el-button>
          </el-form-item>
          <el-form-item label="对账差异：" :label-width="formLabelWidth">
            <el-table
              :data="notarr"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                label="差异描述" :show-overflow-tooltip="true"
                align="right"
                header-align="center"
                width="160">
                <template slot-scope="scope">
                  <span v-if="scope.row.error==1" style="color: red">{{scope.row.remark}}</span>
                  <span v-if="scope.row.error==-1">{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true"
                label="商品名称"
                align="left" width="160"
                header-align="center">
                <template slot-scope="scope">
                  {{ scope.row['商品名称'] }}
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true"
                label="商品代码"
                align="left"
                header-align="center"
                width="120">
                <template slot-scope="scope">{{ scope.row['商品代码'] }}
                </template>
              </el-table-column>
              <el-table-column
                label="球镜"
                align="right"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  {{scope.row['球镜']}}
                </template>
              </el-table-column>
              <el-table-column
                label="柱镜"
                align="right"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  {{scope.row['柱镜']}}
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="right"
                header-align="center"
                width="80" >
                <template slot-scope="scope">
                  {{scope.row['数量']}}
                </template>
              </el-table-column>
              <el-table-column
                label="单价"
                align="right"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  {{(scope.row['单价'])|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="总价"
                align="right"
                header-align="center"
                width="120">
                <template slot-scope="scope">
                  {{(scope.row['总价'])|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="供应号"
                align="right"
                header-align="center" :show-overflow-tooltip="true"
                width="100">
                <template slot-scope="scope">
                  {{scope.row['供应商单号']}}
                </template>
              </el-table-column>
              <el-table-column
                label="采购单号"
                align="center"
                header-align="center" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row['采购单号']}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="销售单号"
                align="left"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  {{ scope.row['销售单号']}}
                </template>
              </el-table-column>
              <el-table-column
                label="跟踪号" :show-overflow-tooltip="true"
                align="right"
                header-align="center"
                width="100">
                <template slot-scope="scope">
                  {{scope.row['跟踪号']}}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="匹配总额：" :label-width="formLabelWidth">
            {{totalmoney|numeric(3,1)}}
          </el-form-item>
          <el-form-item label="匹配记录：" :label-width="formLabelWidth">
            <el-table
              :data="arr"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                prop="seedname" :show-overflow-tooltip="true"
                label="商品名称"
                align="left"
                header-align="center"
                width="160">
                <template slot-scope="scope">
                  {{ scope.row['seedname'] }}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedcode" :show-overflow-tooltip="true"
                label="商品代码"
                align="left"
                header-align="center"
                width="120">
                <template slot-scope="scope">{{ scope.row['seedcode'] }}</template>
              </el-table-column>
              <el-table-column
                prop="packagesize"
                label="规格"
                align="right"
                header-align="center"
                width="160">
                <template slot-scope="scope">
                  {{getPackage(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="right"
                header-align="center"
                width="80"
                prop="totalnumber">
                <template slot-scope="scope">
                  {{scope.row.totalnumber}}
                </template>
              </el-table-column>
              <el-table-column
                label="单价"
                align="right"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  {{(scope.row.costtotalmoney/scope.row.totalnumber)|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="总价"
                align="right"
                prop="costtotalmoney"
                header-align="center"
                width="120">
                <template slot-scope="scope">
                  {{(scope.row.costtotalmoney)|numeric(3,1)}}
                </template>
              </el-table-column>
              <el-table-column
                label="供应号"
                align="right"
                header-align="center" :show-overflow-tooltip="true"
                width="100"
                prop="tracknum">
                <template slot-scope="scope">
                  {{scope.row.tracknum}}
                </template>
              </el-table-column>
              <el-table-column
                prop="erpserial"
                label="采购单号"
                align="center"
                header-align="center" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.erpserial}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="hetongserial"
                label="销售单号"
                align="left"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  {{ scope.row.hetongserial}}
                </template>
              </el-table-column>
              <el-table-column
                label="跟踪号" :show-overflow-tooltip="true"
                align="right"
                header-align="center"
                width="100"
                prop="logisticstracknum">
                <template slot-scope="scope">
                  {{scope.row.logisticstracknum}}
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="canPost">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

  export default {
    name: "aaa",
    data() {
      return {
        canPost:false,
        arr: [],
        notarr: [],
        loading: false,
        dialogFormVisible: false,
        totalmoney: 0,
        remark: '',
        pcustomer: '',
        pcustomerserial: '',
        accountdate: '',
        tableDataExcel: [],
        form: {
          date: '',//表单数据
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          date: [
            {required: true, message: '请选择对账年月', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {
      getPackage(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return (ps.type?(ps.type+" "):"")+"球 "+ps.Y+"，柱 "+ps.Y;
      },
      //导入对账记录
      importEdit() {
        this.$refs.fileupload1.value = ""
        this.notarr = []
        this.arr = []
        this.totalmoney=0;
        this.$refs.fileupload1.click()
      },
      //上传文件
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          for (let j in this.tableDataExcel) {
            this.tableDataExcel[j].hasload=0;
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              this.canPost = false;
              var haserror = false;
              for (let i in data) {//EXCEL中的记录
                var flage = false
                if (data[i].hasOwnProperty("采购单号")&&data[i]["采购单号"] == "合计")
                  continue;
                data[i]["单价"]=(parseFloat(data[i]["总价"])/parseFloat(data[i]["数量"])).toFixed(3);
                console.log(this.tableDataExcel)
                for (let j in this.tableDataExcel) {//数据库的数据
                  if (this.tableDataExcel[j].casestatus == 1||this.tableDataExcel[j].hasload==1)
                    continue;
                  if(data[i].hasOwnProperty("采购单号")){
                    if (!data[i]['采购单号']||!(this.tableDataExcel[j].seedcode.toString() == data[i]['商品代码'].toString() && this.tableDataExcel[j].erpserial.toString() == data[i]['采购单号'].toString()))
                      continue;
                  }else{
                    if (!this.tableDataExcel[j].tracknum||!data[i]['供应商单号']||!(this.tableDataExcel[j].seedcode == data[i]['商品代码'] && this.tableDataExcel[j].tracknum == data[i]['供应商单号']))
                      continue;
                  }
                  console.log(data[i]['采购单号'])
                  if ((!data[i].hasOwnProperty("柱镜")&&!data[i].hasOwnProperty("球镜"))||(!data[i]['柱镜'] && !data[i]['球镜'] )) {//镜架 或者 加工单

                    if (!(this.tableDataExcel[j].packagesize == null || this.tableDataExcel[j].packagesize == ""))
                      continue;
                  } else {
                    if (!(JSON.parse(this.tableDataExcel[j].packagesize).X == data[i]['柱镜'] &&
                      JSON.parse(this.tableDataExcel[j].packagesize).Y == data[i]['球镜']))
                      continue;
                  }

                  flage = true;//有匹配的记录
                  if (parseFloat(this.tableDataExcel[j].totalnumber).toFixed(2) != parseFloat(data[i]['数量']).toFixed(2)) {
                    data[i].remark = '数量不一致，原单：' + this.tableDataExcel[j].totalnumber
                    data[i]["error"] = 1;
                    haserror = true;
                    this.notarr.push(data[i])
                    break;
                  }

                  var costmoney = parseFloat(this.tableDataExcel[j].costtotalmoney / this.tableDataExcel[j].totalnumber).toFixed(3);
                  var newmoney = parseFloat(data[i]['单价']).toFixed(3);
                  if (parseFloat(data[i]['单价']) < 0) {
                    data[i].remark = '单价必须大于等于0'
                    data[i]["error"] = 1;
                    haserror = true;
                    this.notarr.push(data[i])
                    break;
                  }

                  data[i]["error"] = -1;
                  this.tableDataExcel[j].totalmoneytax = 0;

                  if (costmoney != newmoney) {
                    data[i].remark = '单价不一致，原单：' + costmoney
                    this.tableDataExcel[j].costprice=parseFloat(data[i]['单价'])
                    this.tableDataExcel[j].totalmoneytax = this.tableDataExcel[j].costtotalmoney;//存储原始价格
                    this.tableDataExcel[j].costtotalmoney = this.tableDataExcel[j].totalnumber * this.tableDataExcel[j].costprice
                    this.notarr.push(data[i])
                  }
                  //单价不一致的 要修改
                  this.tableDataExcel[j].hasload=1;
                  this.arr.push(this.tableDataExcel[j])
                  this.totalmoney += parseFloat(this.tableDataExcel[j].costtotalmoney.toFixed(3));
                  break;
                }
                if (!flage) {
                  data[i].remark = '该条记录匹配不上'
                  data[i]["error"] = 1;
                  haserror = true;
                  this.notarr.push(data[i])
                }
              }

              if (!haserror && this.arr.length > 0)
                this.canPost = true;
            }
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      show(tableDataExcel, pcustomerserial, pcustomer) {
        this.initForm();
        this.dialogFormVisible = true;
        // this.totalmoney = totalmoney;
        this.pcustomer = pcustomer;
        this.pcustomerserial = pcustomerserial;
        this.tableDataExcel = tableDataExcel
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            var returnD=[];
            for(var i in this.arr){
              var row=this.arr[i];
              returnD.push({erpserial:row.erpserial,seedcode:row.seedcode,packagesize:row.packagesize,
                costprice:row.costprice,costtotalmoney:row.costtotalmoney,totalmoneytax:row.totalmoneytax,totalnumber:row.totalnumber});
            }
            this.loading = true
            let temp = new Date(this.form.date)
            let month = (temp.getMonth() + 1)
            this.$emit("afterselduizhangdate", temp.getFullYear() + "" + (month < 10 ? "0" + month : month), this.accountdate, this.totalmoney, this.remark, returnD)
            this.dialogFormVisible = false
          }
        })
      },
      changedate() {
        let date = Object.assign(this.form.date, date)
        this.accountdate = date.replace("-", "")
      },

      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.loading=false;
        this.canPost=false;
        this.form.date = ""
        this.totalmoney = 0
        this.remark = ''
        this.notarr = []
        this.arr = []
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/SelDate.vue